// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2BnLL","unreadBadge":"styles_unreadBadge__QwZlW","modalContent":"styles_modalContent__2Fc4O","modal":"styles_modal__1DwsV"};